export function formatApiError(error, fallbackMessage) {
    const responseData = error?.response?.data || {};
    const details = responseData.details;

    if (Array.isArray(details?.missing_sections) && details.missing_sections.length) {
        return `${responseData.message || fallbackMessage} Missing sections: ${details.missing_sections.join(", ")}.`;
    }

    if (details?.provider_response?.message) {
        return details.provider_response.message;
    }

    if (details?.provider_response?.error) {
        return details.provider_response.error;
    }

    if (details && typeof details === "object") {
        const detailValues = Object.values(details)
            .flatMap((value) => Array.isArray(value) ? value : [value])
            .filter(Boolean)
            .map((value) => String(value).trim())
            .filter(Boolean);

        if (detailValues.length) {
            const lead = responseData.message && responseData.message !== "Validation failed."
                ? `${responseData.message} `
                : "";
            return `${lead}${detailValues.join(" ")}`.trim();
        }
    }

    return (
        responseData.message
        || error?.message
        || fallbackMessage
    );
}
